import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../PrintStyles.css'; // Gunakan file CSS yang sama

const InvoicePreview = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { filteredData = [], selectedColumns = [], columnLabels = {} } = location.state || {};

  if (!filteredData.length) {
    return (
      <div className="p-8 text-center">
        <p className="mb-4 text-lg text-gray-700">Tidak ada data untuk ditampilkan.</p>
        <button onClick={() => navigate(-1)} className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700">
          Kembali ke halaman filter
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-8 pt-10 pl-64 mx-auto text-black bg-white a4-landscape print:pl-0 print:pt-0 print:p-10 print:m-0 print:bg-white">
      <h1 className="mb-6 text-2xl font-bold text-center">INVOICE</h1>

      <div className="overflow-auto">
        <table className="min-w-full text-xs border border-black">
          <thead>
            <tr className="bg-gray-200">
              {selectedColumns.map((col) => (
                <th key={col} className="px-2 py-1 text-left border border-black">
                  {columnLabels[col] || col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData.map((row, idx) => (
              <tr key={idx}>
                {selectedColumns.map((col) => (
                  <td key={col} className="px-2 py-1 border border-black">
                    {row[col] ?? '-'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end mt-8 print:hidden">
        <button onClick={() => navigate(-1)} className="px-4 py-2 mr-2 text-white bg-gray-500 rounded hover:bg-gray-600">
          Kembali
        </button>
        <button onClick={() => window.print()} className="px-4 py-2 text-white bg-green-600 rounded hover:bg-green-700">
          Cetak
        </button>
      </div>
    </div>
  );
};

export default InvoicePreview;
